module.exports = __webpack_public_path__ + "static/media/pending.12693737.svg";